// Source: ASG Cert GmbH ISCC EU audit, Neutral Fuels Dubai (DIP 2), Dec 2025 (RED III).
// Factors are VOLUMETRIC (kg CO2eq/litre) to match the litre-based input below.
// B100 volumetric saving = 2.97763 / 3.447027 = 86.4% (volumetric basis).
// Do not "correct" to the 84.7% headline — that is the ENERGY-basis figure, a different
// (also-audited) basis; switching it would desync the % from the per-litre kg savings.
export const emissionData = {
    'B100 (UCOME/FAME)': { emissionFactor: 0.46940, savingsEmissionFactor: 2.97763 },
    B20: { emissionFactor: 2.852, savingsEmissionFactor: 0.59553 },
    B10: { emissionFactor: 3.149, savingsEmissionFactor: 0.29776 },
    B7: { emissionFactor: 3.24, savingsEmissionFactor: 0.20843 },
    B5: { emissionFactor: 3.298, savingsEmissionFactor: 0.14888 },
    B0: { emissionFactor: 3.447027, savingsEmissionFactor: 0 },
};

// EPA Greenhouse Gas Equivalencies Calculator: one urban tree seedling grown for
// 10 years sequesters ~0.060 metric tons = 60 kg CO2 (cumulative, ~16.5 seedlings per tonne).
export const CO2PerTreeSeedling10yr = 60;
